import { Label } from '@up2stay/up2promo-ui';

import { ProductFormProfileUserField } from '@/core/components/products/product-form-fields/profile-user-field';
import { useDictionary } from '@/core/providers/dictionary-provider';
import type { ProductsDict } from '@/routes/app/products/products.types';
import { ProductsSetupStepShell } from '@/routes/app/products-setup-wizard/products-setup-step-shell';

export function ProductsSetupStepProfile({
  workspaceId,
  userId,
  onUserChange,
  hideProfileUserPicker,
  lockedProfileUserLabel,
}: {
  workspaceId?: string;
  userId: string | null;
  onUserChange: (userId: string | null) => void;
  hideProfileUserPicker?: boolean;
  lockedProfileUserLabel?: string;
}) {
  const dict = useDictionary();
  const productsDict = (dict as { products?: ProductsDict }).products;
  const setup = (productsDict?.setup ?? {}) as Record<
    string,
    string | undefined
  >;

  return (
    <ProductsSetupStepShell
      title={setup.profileStepTitle ?? ''}
      description={
        hideProfileUserPicker && lockedProfileUserLabel
          ? setup.profileStepDescriptionOwn
          : setup.profileStepDescription
      }
    >
      {hideProfileUserPicker && lockedProfileUserLabel ? (
        <div className="flex flex-col gap-2">
          <Label>
            {setup.profileUser ??
              productsDict?.edit?.routing?.routingProfile ??
              ''}
          </Label>
          <p className="rounded-[var(--radius-nested)] border border-border/70 bg-muted/30 px-4 py-3 text-[14px] font-medium">
            {lockedProfileUserLabel}
          </p>
        </div>
      ) : (
        <ProductFormProfileUserField
          workspaceId={workspaceId}
          value={userId}
          onChange={onUserChange}
          dict={productsDict}
          required
        />
      )}
    </ProductsSetupStepShell>
  );
}
